export function concat<T>(arrays: T[][]): T[] {
  return arrays.reduce((acc, array) => acc.concat(array), []);
}
